import React from "react";
import { Button, useTheme } from "@mui/material";

export default function GradientButton({
  children,
  px = 5,
  py = 1.2,
  borderRadius = "28px",
  startColor,
  endColor,
  ...props
}) {
  const theme = useTheme();

  const defaultStartColor = theme.palette.primary.main;
  const defaultEndColor = theme.palette.primary.light;

  return (
    <Button
      variant="contained"
      {...props}
      sx={{
        px,
        py,
        background: `linear-gradient(90deg, ${startColor || defaultStartColor} 0%, ${endColor || defaultEndColor} 100%)`,
        borderRadius,
        color: theme.palette.primary.contrastText,
        textTransform: "none",
        ...props.sx,
      }}
    >
      {children}
    </Button>
  );
}
